<template>
    <i class="ath-collapse-icon" :class="uiCname" aria-hidden="true"></i>
</template>

<script>
export default {
    name: 'mead-collapse-icon',
    props: {
        /**
         * Whether the associated section is expanded (true) or collapsed (false).
         * Drives which chevron direction is displayed.
         */
        value: {type: Boolean, default: () => false},
        /**
         * Visual style of the icon: 'tree' shows a right/down chevron pair, while
         * 'accordion' shows a down/up chevron pair.
         */
        uiStyle: {type: String, default: () => 'tree'},
    },
    computed: {
        uiCname: function () {
            if (this.uiStyle === 'accordion') {
                return this.value ? 'lnr-chevron-up' : 'lnr-chevron-down';
            }

            return this.value ? 'lnr-chevron-down' : 'lnr-chevron-right';
        },
    },
};
</script>
